/* global translation */
require('./quantity');
require('./mini-cart');
require('./swiper-init');
require('./store-locator');
require('./maksimer-map');

jQuery(($) => {
  let isOpen = false;
  $('a.acc-link.logged').on('click', (e) => {
    e.preventDefault();
    if (!isOpen) {
      $('.my-account-links').css('display', 'flex');
      $('.my-account-wrapper .dropdown').show();
      $('.widget_shopping_cart').hide();
      $('.cart-contents .dropdown').hide();
      $('.mini-dropdown-list').hide();
      $('.wishlist_icon_wrap .dropdown').hide();
      isOpen = !isOpen;
    } else {
      $('.my-account-links').css('display', 'none');
      $('.my-account-wrapper .dropdown').hide();
      isOpen = !isOpen;
    }
  });
});

jQuery(($) => {
  let isOpen = false;
  $('a.cart-contents').on('click', (e) => {
    e.preventDefault();
    if (!isOpen) {
      $('.widget_shopping_cart').show();
      $('.cart-contents .dropdown').show();
      $('.my-account-links').css('display', 'none');
      $('.my-account-wrapper .dropdown').hide();
      $('.mini-dropdown-list').hide();
      $('.wishlist_icon_wrap .dropdown').hide();
      isOpen = !isOpen;
    } else {
      $('.widget_shopping_cart').hide();
      $('.cart-contents .dropdown').hide();
      isOpen = !isOpen;
    }
  });
  $('body').on('click', (event) => {
    if (!$(event.target).is('a.cart-contents')) {
      $('.widget_shopping_cart').hide();
      $('.cart-contents .dropdown').hide();
      isOpen = !isOpen;
    }
  });
});
jQuery(($) => {
  let isOpen = false;
  $('a.toggle-mini-wishlist').on('click', (e) => {
    e.preventDefault();
    if (!isOpen) {
      $('.mini-dropdown-list').show();
      $('.wishlist_icon_wrap .dropdown').show();
      $('.my-account-links').css('display', 'none');
      $('.my-account-wrapper .dropdown').hide();
      $('.widget_shopping_cart').hide();
      $('.cart-contents .dropdown').hide();
      isOpen = !isOpen;
    } else {
      $('.mini-dropdown-list').hide();
      $('.wishlist_icon_wrap .dropdown').hide();
      isOpen = !isOpen;
    }
  });
  $('body').on('click', (event) => {
    if (!$(event.target).is('a.toggle-mini-wishlist')) {
      $('.mini-dropdown-list').hide();
      $('.wishlist_icon_wrap .dropdown').hide();
      isOpen = !isOpen;
    }
  });
  $('.header-top span').on('click', (e) => {
    e.preventDefault();
    $('.header-top').hide();
  });
});


jQuery(($) => {
  $('form.woocommerce-product-search').find('input[type=search]').each(function (ev) {
    if (!$(this).val()) {
      $(this).attr('placeholder', 'Søk etter produkt eller merke');
    }
  });
});

jQuery(($) => {
  $(document).on('click', 'button.menu-toggle', (e) => {
    $('.storefront-primary-navigation').toggleClass('mobile-menu-toggled');
  });
});

jQuery(($) => {
  const $window = $(window);
  function footerToggle() {
    const windowsize = $window.width();
    if (windowsize < 440) {
      const widgetTitle = $('.footer-widgets .footer-widget-1 #nav_menu-2 > .widget-title, .footer-widgets .footer-widget-1 #nav_menu-3 > .widget-title, .footer-widgets .footer-widget-2 #nav_menu-4 > .widget-title, .footer-widgets .footer-widget-2 #nav_menu-5 > .widget-title');
      widgetTitle.each(function filterTitleEach() {
        if ($(this).parent().find('.chosen').length > 0) {
          $(this).addClass('active');
          $(this).parent().find('ul').show();
        }
        $(this).on('click', (e) => {
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).parent().find('ul').slideToggle();
        });
      });
    }
  }
  // $(window).resize(footerToggle);
  footerToggle();
});

jQuery(($) => {
  $('.child-categories').parent('li').addClass('parent-cat');
  $('.sub-child-categories').parent('li').addClass('sub-parent-cat');
});


jQuery(($) => {
  const categoryTitle = $('ul.parent-categories li.parent-cat > a .icon-holder');
  const subCategoryTitle = $('ul.child-categories li.sub-parent-cat > a .icon-holder');
  const taxTitle = $('ul.parent-leverandører-list li.parent-taxonomy > a .icon-holder');
  categoryTitle.each(function filterTitleEach() {
    if ($(this).parent().parent().find('.chosen').length > 0) {
      $(this).parent().addClass('active');
      $(this).parent().parent().find('ul.child-categories')
        .show();
    }
    $(this).on('click', (e) => {
      e.preventDefault();
      $(this).parent().toggleClass('active');
      $(this).parent().parent().find('ul.child-categories')
        .slideToggle();
    });
  });
  subCategoryTitle.each(function filterTitleEach() {
    if ($(this).parent().parent().find('.chosen').length > 0) {
      $(this).parent().addClass('active');
      $(this).parent().parent().find('ul.sub-child-categories')
        .show();
    }
    $(this).on('click', (e) => {
      e.preventDefault();
      $(this).parent().toggleClass('active');
      $(this).parent().parent().find('ul.sub-child-categories')
        .slideToggle();
    });
  });
  taxTitle.each(function filterTitleEach() {
    if ($(this).parent().find('.chosen').length > 0) {
      $(this).addClass('active');
      $(this).parent().find('ul.child-taxonomies').show();
    }
    $(this).on('click', (e) => {
      e.preventDefault();
      $(this).parent().toggleClass('active');
      $(this).parent().parent().find('ul.child-taxonomies')
        .slideToggle();
    });
  });
});

jQuery(($) => {
  const filterTitle = $('section.widget_layered_nav h2.widget-title');
  filterTitle.each(function filterTitleEach() {
    // if ($(this).parent().find('.chosen').length > 0) {
    //   $(this).parent().addClass('active');
    //   $(this).parent().find('ul').show();
    // }
    $(this).on('click', (e) => {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().find('ul').slideToggle();
    });
  });
});

const maksimerProductHover = ($) => {
  $('.woocommerce-LoopProduct-link img').on('mouseenter', function productHoverIn() {
    $(this).parent().addClass('active');
  }).on('mouseleave', function productHoverOut() {
    $(this).parent().removeClass('active');
  });
  $('.wc-block-grid__product-image').on('mouseenter', function productBlockHoverIn() {
    $(this).parent().addClass('active');
  }).on('mouseleave', function productBlockHoverOut() {
    $(this).parent().removeClass('active');
  });
};

maksimerProductHover(jQuery);

jQuery(($) => {
  $(document).ajaxComplete(() => {
    maksimerProductHover($);
  });
});

/**
 * Selecting single product color attributes.
 */
const maksimerColorSwatches = () => {
  const colors = document.querySelectorAll('.variations_form .color-picker .color-variations span');
  const select = document.querySelector('select#pa_color');
  if (colors && select) {
    const updateColors = () => {
      const colorOptions = select.querySelectorAll('option');
      const values = [];
      colorOptions.forEach((colorOption) => {
        values.push(colorOption.getAttribute('value'));
      });
      colors.forEach((element) => {
        const slug = element.getAttribute('data-slug');
        if (values.includes(slug)) {
          element.classList.remove('hidden');
        } else {
          element.classList.add('hidden');
        }
      });
    };
    select.addEventListener('DOMNodeRemoved', () => updateColors());
    select.addEventListener('DOMNodeInserted', () => updateColors());
    colors.forEach((color) => {
      color.addEventListener('click', (e) => {
        colors.forEach((element) => {
          element.classList.remove('active');
        });
        e.currentTarget.classList.toggle('active');
        const currentSlug = e.currentTarget.getAttribute('data-slug');
        select.value = currentSlug;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (colors.length > 0) {
      select.parentNode.parentNode.style.display = 'none';
    }
  }
}; maksimerColorSwatches();

/**
 * Mega menu.
 */
jQuery(($) => {
  const link = $('.primary-navigation .maksimer-mega').prev();
  const close = $('.maksimer-mega-close');
  link.on('click', (e) => {
    e.preventDefault();
    if (e.currentTarget.parentNode.classList.contains('maksimer-mega-active')) {
      e.currentTarget.parentNode.classList.remove('maksimer-mega-active');
    } else {
      link.parent().removeClass('maksimer-mega-active');
      e.currentTarget.parentNode.classList.add('maksimer-mega-active');
    }
  });
  close.on('click', (e) => {
    $(e.currentTarget).parent().parent().removeClass('maksimer-mega-active');
  });
});

// /**
//  * Mega menu brand.
//  */
// jQuery(($) => {
//   const link = $('.primary-navigation .maksimer-mega').prev();
//   const close = $('.maksimer-mega-close');
//   link.on('click', (e) => {
//     e.preventDefault();
//     if (e.currentTarget.parentNode.classList.contains('maksimer-mega-active')) {
//       e.currentTarget.parentNode.classList.remove('maksimer-mega-active');
//     } else {
//       link.parent().removeClass('maksimer-mega-active');
//       e.currentTarget.parentNode.classList.add('maksimer-mega-active');
//     }
//   });
//   close.on('click', (e) => {
//     $(e.currentTarget).parent().parent().removeClass('maksimer-mega-active');
//   });
// });

/**
 * Mobile menu.
 */
jQuery(($) => {
  const link = $('.maksimer-navigation .menu > li > a');
  link.on('click', (e) => {
    if (e.currentTarget.parentNode.classList.contains('menu-item-has-children')) {
      e.preventDefault();
      e.currentTarget.parentNode.classList.toggle('active');
    }
    if (e.currentTarget.parentNode.getElementsByClassName('maksimer-mega')[0]) {
      e.preventDefault();
      e.currentTarget.parentNode.classList.toggle('maksimer-mega-active');
    }
  });
});

function limitPostExcerpt() {
  const elements = document.querySelectorAll('.kt-blocks-post-grid-item-inner > .entry-content');
  // elements.forEach((element, index) => {
  //   element.childNodes[0].textContent = `${element.childNodes[0].textContent.substring(0, 100)} ...`;
  // });
  // const posts = document.querySelectorAll('.taxonomy-description p');
  // posts.forEach((post, index) => {
  //   post.textContent = `${post.textContent.substring(0, 150)} ...`;
  // });
}

limitPostExcerpt();

jQuery(($) => {
  const filterTitle = $('.maksimer-map-loop-single .title-wrapper img');
  filterTitle.each(function filterTitleEach() {
    if ($(this).parent().find('.chosen').length > 0) {
      $(this).addClass('active');
      $(this).parent().parent().find('.single-store-info')
        .show();
    }
    $(this).on('click', (e) => {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().parent().find('.single-store-info')
        .slideToggle();
    });
  });
});

jQuery(document).on('click', '#maksimer-map-search-button', (e) => {
  e.preventDefault();
  jQuery('a.map-location-link').each(function (i, obj) {
    if (!jQuery('#maksimer-map-search-input').val().trim().length) {
      jQuery(this).show();
    } else if (jQuery(this).data('town') === jQuery('#maksimer-map-search-input').val().trim()) {
      jQuery(this).show();
    } else if (jQuery(this).data('zip') === jQuery('#maksimer-map-search-input').val()) {
      jQuery(this).show();
    } else {
      jQuery(this).parent().parent().hide();
    }
  });
});

jQuery(($) => {
  $(document).on('click', '.trigger-filters', () => {
    $('#filters-sidebar').toggleClass('active');
  });
});

jQuery(($) => {
  $('.advanced-product-slider .hover-image').prev('img').css('opacity', '0');
});

jQuery(($) => {
  const activeurl = window.location.href;
  // const newActiveUrl = activeurl.split('page/2/').join(', ').split('?');
  const removeUnwanted = (active) => {
    if (active.includes('?')) {
      const activeurll = active.slice(0, active.indexOf('?'));
      return activeurll;
    } if (active.includes('page')) {
      const activeurll = active.slice(0, active.indexOf('page'));
      return activeurll;
    }
    return activeurl;
  };
  // const activeurl = window.location;

  $(`li.child-cat a[href="${removeUnwanted(activeurl)}"]`).parent().parent()
    .slideToggle();
  $(`li.child-cat a[href="${removeUnwanted(activeurl)}"]`).siblings().slideToggle();
  $(`li.child-cat a[href="${removeUnwanted(activeurl)}"]`).addClass('active');
  $(`li.child-cat a[href="${removeUnwanted(activeurl)}"]`).parent().parent().parent()
    .children('a')
    .addClass('active');
  $(`li.child-cat a[href="${removeUnwanted(activeurl)}"]`).css('color', '#bfd73e');

  $(`li.sub-child-cat a[href="${removeUnwanted(activeurl)}"]`).parent().parent().parent()
    .parent()
    .slideToggle();
  $(`li.sub-child-cat a[href="${removeUnwanted(activeurl)}"]`).siblings().slideToggle();
  $(`li.sub-child-cat a[href="${removeUnwanted(activeurl)}"]`).addClass('active');
  $(`li.sub-child-cat a[href="${removeUnwanted(activeurl)}"]`).css('color', '#bfd73e');
  // $(`li.sub-child-cat a[href="${activeurl}"]`).parent().parent().parent()
  //   .parent()
  //   .parent()
  //   .child('a')
  //   .toggleClass('active');
  // $(`li.sub-child-cat a[href="${activeurl}"]`).parent().parent().parent()
  //   .parent()
  //   .child('a')
  //   .toggleClass('active');
  $('li.parent-cat > a.active').parent().siblings()
    .css('display', 'none');

  $(`li.child-tax a[href="${removeUnwanted(activeurl)}"]`).siblings().slideToggle();
  $(`li.child-tax a[href="${removeUnwanted(activeurl)}"]`).addClass('active');
  $(`li.child-tax a[href="${removeUnwanted(activeurl)}"]`).css('color', '#bfd73e');
  $(`li.child-tax a[href="${removeUnwanted(activeurl)}"]`).parent().parent()
    .slideToggle();
  // $(`li.child-tax a[href="${activeurl}"]`).parent().parent().parent()
  //   .child('a')
  //   .addClass('active');
});

jQuery(($) => {
  $('li.product .above-image').find('a:first-of-type .image-wrapper img').css('height', '367px');
});
jQuery(($) => {
  $('nav.woocommerce-pagination ul.page-numbers li span.current').parent().css('border', '2px solid #c0d73e');
});


function getCoordintes() {
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  function success(pos) {
    const crd = pos.coords;
    const lat = crd.latitude.toString();
    const lng = crd.longitude.toString();
    const coordinates = [lat, lng];
    // eslint-disable-next-line no-use-before-define
    getCity(coordinates);
  }

  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  navigator.geolocation.getCurrentPosition(success, error, options);
}
// Step 2: Get city name
function getCity(coordinates) {
  const xhr = new XMLHttpRequest();
  const lat = coordinates[0];
  const lng = coordinates[1];

  function processRequest(e) {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);

      const city = response.results[0].address_components[2].long_name;
      jQuery('input#billing_postcode').val(city);
      jQuery('form.kps-postalcode-search button').trigger('click');
    }
  }
  // Paste your LocationIQ token below.
  xhr.open('GET', `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyCuUWsX-PAtS5I7SMwdse6YG2YeeoI8RZs`, true);
  xhr.send();
  xhr.onreadystatechange = processRequest;
  xhr.addEventListener('readystatechange', processRequest, false);
}

jQuery(($) => {
  $('form.cart > button.kps-pick-up-single-product').on('click', (e) => {
    e.preventDefault();
    getCoordintes();
  });
  const $window = $(window);

  function checkWidth() {
    const windowsize = $window.width();
    if (windowsize < 700) {
      $('button.kps-opener-button').on('click', (e) => {
        $('html, body').animate({
          scrollTop: $('#kps-single-product-main').offset().top,
        }, 2000);
      });
    }
  }
  checkWidth();
  $(window).resize(checkWidth);
});

jQuery(($) => {
  const currentElemSource = $('.category-container h3 a').attr('href');
  $('.featured-category').wrapInner(`<a href="${currentElemSource}" class="wrapper-link"></a>`);
});


jQuery(($) => {
  $('#mc4wp-subscribe').click(function () {
    if ($(this).prop('checked') === true) {
      $('#hidden_email').val($('#reg_email').val());
    }
  });
  $('#reg_email').on('change', () => {
    if ($('#mc4wp-subscribe').prop('checked') === true) {
      $('#hidden_email').val($('#reg_email').val());
    }
  });
});

jQuery(($) => {
  const wishlistUl = $('.mini-dropdown-list .wishlist-container-inner ul.mini-dropdown-products').children('li').length;
  $('.toggle-mini-wishlist').append(`<span class="badge">${wishlistUl}</span>`);
});

const maksimerRefreshMiniWishlist = () => {
  jQuery.post(translation.ajaxurl, {
    action: 'maksimer_ajax_wishlist_refresh',
  }, (response) => {
    let data;
    try { data = jQuery.parseJSON(response); } catch (err) {
      console.log(`Problem parsing json string : ${response}`); // eslint-disable-line no-console
      return null;
    }
    jQuery('.wishlist-container-inner').replaceWith(data);
    const newWishlistUl = jQuery('.mini-dropdown-list .wishlist-container-inner ul.mini-dropdown-products').children('li').length;
    jQuery('.toggle-mini-wishlist span.badge').text(newWishlistUl);
    return null;
  });
};
const miniWishListContainer = document.getElementById('mini-wishlist');

jQuery(document).on('click', '#mini-wishlist ul.mini-dropdown-products a.remove-item', (event) => {
  event.preventDefault();
  const link = event.currentTarget;
  const { postId, wishlistId } = link.dataset;
  const confirmed = window.confirm(`${translation.delete_product} "${link.dataset.productName}"?`);

  if (!confirmed) {
    return;
  }

  miniWishListContainer.classList.add('wait');

  jQuery.post(translation.ajaxurl, { action: 'maksimer_ajax_wishlist_remove_item', wishlist_id: wishlistId, post_id: postId }, () => {
    maksimerRefreshMiniWishlist();
    setTimeout(() => {
      miniWishListContainer.classList.remove('wait');
    }, 500);
  });
});


jQuery(document).on('click', '.product a.krokedil-wishlist, .wc-block-grid__product a.krokedil-wishlist', () => {
  maksimerRefreshMiniWishlist();
});

jQuery(($) => {
  $('span.page-numbers.dots').parent().hide();
  $('span.page-numbers.current').parent().addClass('show');
  $('span.page-numbers.current').parent().prev().addClass('show');
  $('span.page-numbers.current').parent().next().addClass('show');
  $('a.prev.page-numbers').parent().addClass('show');
  $('a.next.page-numbers').parent().addClass('show');
});
